import { Validator } from "./Validator";

export class NotEmptyValidator extends Validator
{
  validate( value:string )
  {
    let result = value && value.trim() !== "";
    
    if ( result )
    {
      return true;
    }

    this.error( "The field can't be empty" );
    return false;
  }
}